// add-existing-user-dialog.component.ts
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuperadminService } from '../../../services/superadmin.service';
import { MatInputModule } from '@angular/material/input';

export interface AddExistingUserDialogData {
  org: { id: number; org_name: string };
  orgPermissions: { id: number; key: string; label: string; category: string }[];
}

@Component({
  selector: 'app-add-existing-user-dialog',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './add-existing-user-dialog.component.html',
  styleUrl: './add-existing-user-dialog.component.scss',
})
export class AddExistingUserDialogComponent implements OnInit {
  availableUsers: any[] = [];
  selectedUserId: number | null = null;
  selectedPermissionIds: Set<number> = new Set();
  saving = false;
  loading = true;

  constructor(
    private superadminService: SuperadminService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AddExistingUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddExistingUserDialogData,
  ) {}

  ngOnInit(): void {
    this.superadminService.getUsersNotInOrg(this.data.org.id).subscribe({
      next: (res) => {
        this.availableUsers = res.data ?? [];
        this.loading = false;
      },
      error: () => (this.loading = false),
    });
  }

  togglePermission(id: number): void {
    if (this.selectedPermissionIds.has(id)) {
      this.selectedPermissionIds.delete(id);
    } else {
      this.selectedPermissionIds.add(id);
    }
  }

  onUserChange(): void {
    this.selectedPermissionIds = new Set();
  }

  get permissionCategories(): string[] {
    return [...new Set(this.data.orgPermissions.map(p => p.category))];
  }

  getPermsByCategory(cat: string) {
    return this.data.orgPermissions.filter(p => p.category === cat);
  }

  onConfirm(): void {
    if (!this.selectedUserId || !this.selectedPermissionIds.size) return;
    this.saving = true;

    this.superadminService
      .assignUserToOrganization(
        this.selectedUserId,
        this.data.org.id,
        Array.from(this.selectedPermissionIds),
      )
      .subscribe({
        next: () => {
          this.snackBar.open('User added to organization.', 'Close', { duration: 3000 });
          this.dialogRef.close(true);
        },
        error: () => (this.saving = false),
      });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}